<section class="price-list">
    <header class="price-list-header">
        <span class="material-symbols-outlined">price_check</span>
        <div>
            <h2>{{ 'Price list' | translate }}</h2>
            <p>{{ 'All prices are charged in credits.' | translate }}</p>
        </div>
    </header>

    <div class="pricing-explanation">
        <p><strong>{{ 'First item' | translate }}:</strong> {{ 'One item in the order is charged at its print price. When an order contains different items, the item with the highest print price is used.' | translate }}</p>
        <p><strong>{{ 'Additional items' | translate }}:</strong> {{ 'Every remaining item in the order is charged at its additional price.' | translate }}</p>
        <p><strong>{{ 'Shipping' | translate }}:</strong> {{ 'An order normally has one shipping charge, set to the highest shipping price among the items included in the order.' | translate }}</p>
    </div>

    <div class="price-table-wrap" *ngIf="prices.length; else noPrices">
        <table class="price-table">
            <thead>
                <tr>
                    <th>{{ 'SKU' | translate }}</th>
                    <th class="numeric">{{ 'First item' | translate }}</th>
                    <th class="numeric">{{ 'Additional item' | translate }}</th>
                    <th class="numeric">{{ 'Shipping' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let price of prices">
                    <td><code>{{ price.sku }}</code></td>
                    <td class="numeric">{{ price.printPrice | number:'1.0-2' }}</td>
                    <td class="numeric">{{ price.additionalPrice | number:'1.0-2' }}</td>
                    <td class="numeric">{{ price.shippingPrice | number:'1.0-2' }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <ng-template #noPrices>
        <div class="empty-state">
            <span class="material-symbols-outlined">price_change</span>
            <p>{{ 'No prices are available for this store yet.' | translate }}</p>
        </div>
    </ng-template>
</section>
